// extracted by mini-css-extract-plugin
module.exports = {"card":"CandidateCard_card__mtIeJ"};